import React from "react";
import Situation from "../../../components/common/Situation";

const ContractSituation = () => {
  return <Situation type="contract" />;
};

export default ContractSituation;
